<script>
import { mapActions } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';


export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
        DatePicker,
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            form: {
                id: '',
                name: '',
                date: '',
                value: '',
            },
            money: {
                decimal: '.',
                thousands: '',
                prefix: '',
                suffix: '',
                precision: 3, // Aquí defines los 3 decimales
                masked: false
            }
        }
    },
    methods: {
        closedModal() {
            this.form.id = '';
            this.form.name = '';
            this.form.date = '';
            this.form.value = '';
            this.$modal.hide('addINPC');
        },
        async saveBuildings() {
            let form = this.form;
            console.log(form);
            let _endpoint = '/inpc';
            if (form.id != "") {
                form._method = 'PUT';
                _endpoint = `/inpc/${form.id}`;
            }
            try {
                let { data } = await request.postMedia(_endpoint, form)
                if (data) {
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-load-inpc');
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    mounted() {
    },
    created() {
        Event.$on("event-show-addINPC", (account) => {
            console.log(account);
            if (account.id) {
                this.form.id = account.id;
                this.form.name = account.name;
                this.form.date = account.date;
                this.form.value = account.value;
            }
            this.$modal.show('addINPC');
        });
    }
}
</script>

<template>
    <modal v-bind:click-to-close="false" name="addINPC" :width="'300px'" :height="'auto'">
        <form @submit.prevent="saveBuildings" method="post" enctype="multipart/form-data">
            <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                    class="fa-solid fa-xmark"></i> </button>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">INPC</h5>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <label>Nombre</label>
                        <input type="text" class="form-control" :disabled="!prop_edit" v-model="form.name">
                        <div v-if="errors && errors.name" class="text-danger">{{ errors.name[0] }}</div>
                    </div>

                    <div class="col-md-12 mt-1">
                        <label>Fecha</label>
                        <date-picker v-model="form.date" :disabled="!prop_edit" required="required"
                            valueType="format"></date-picker>
                        <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                    </div>

                    <div class="col-md-12 mt-1">
                        <label>Valor</label>
                        <input v-money="money" v-model="form.value" class="form-control">
                        <div v-if="errors && errors.value" class="text-danger">{{ errors.value[0] }}</div>
                    </div>

                    <div class="col-md-12">
                        <hr>
                        <button type="submit" :disabled="!prop_edit" class="btn float-right btn-outline-success">
                            <i class="fas fa-save"></i> Guardar
                        </button>
                        <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>